// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router/index'
import iView from 'iview'
import 'iview/dist/styles/iview.css'
import 'jquery'
import axios from 'axios'
import navbar from './components/Common/Navbar.vue'
import './lib/validate/validate'
import config from './lib/config'
import local from './lib/Local'
import i18n from './lib/i18n/i18n'
import AMap from 'vue-amap'
import Toast from './lib/toast/toast'
import './lib/fb_login.js'

Vue.config.productionTip = false
axios.defaults.baseURL = config.baseUrl
Vue.prototype.$http = axios
Vue.prototype.$config = config
Vue.prototype.Local = local
Vue.prototype.$busEvent = new Vue({})
Vue.prototype.$forget = new Vue({})

Vue.component(navbar.name)
Vue.use(Toast)
Vue.use(iView)
Vue.use(AMap)

AMap.initAMapApiLoader({
    // 申请的高德key
    key: 'e75bb28af1ddbb24d66fb50652db8507',
    // 插件集合
    plugin: ['AMap.Autocomplete', 'AMap.PlaceSearch', 'AMap.Scale', 'AMap.OverView', 'AMap.ToolBar', 'AMap.MapType', 'AMap.PolyEditor', 'AMap.CircleEditor']
})

// 路由权限
// router.beforeEach((to, from, next) => {
//     if (!local.get('users')) {
//         if (to.path.indexOf('/personalsssss') >= 0) {
//             next({
//                 path: '/'
//             })
//         } else {
//             next()
//         }
//     } else {
//         next()
//     }
// })

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    i18n,
    template: '<App/>',
    components: {App}
})



// WEBPACK FOOTER //
// ./src/main.js